export default __webpack_public_path__ + "static/media/dessert05.b0085a4b.png";